"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isCurrentPageExcluded(excludedPageUrls) {
    if (typeof excludedPageUrls === 'string') {
        excludedPageUrls = JSON.parse(excludedPageUrls);
    }
    return excludedPageUrls.indexOf(window.location.pathname) >= 0;
}
exports.isCurrentPageExcluded = isCurrentPageExcluded;
